<template>
  <div class="space-y-4">
    <div v-if="deliveryStatus || notification" class="space-y-4">
      <pre v-if="deliveryStatus" v-text="deliveryStatus" class="text-xs mb-4"></pre>
      <pre
        v-if="notification"
        v-text="notification"
        class="bg-green-100 border border-green-400 p-4 mb-4 rounded-md text-xs"
      ></pre>
      <div class="bg-orange-100 border border-orange-400 p-4 mb-4 rounded-md">
        <h3 class="text-sm font-medium">Possible reasons:</h3>
        <ul class="list-disc list-inside mt-2 text-xs">
          <li v-for="(reason, idx) in possibleReasons" :key="idx">{{ reason }}</li>
        </ul>
      </div>
    </div>
    <BaseButton primary outline small @click="showRaw = !showRaw">
      {{ showRaw ? 'Hide' : 'Show' }} raw
    </BaseButton>
    <div v-if="showRaw" class="bg-gray-100 text-xs p-4 rounded max-h-96 overflow-auto">
      <pre v-text="raw"></pre>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bounceLog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showRaw: false,
    };
  },
  computed: {
    possibleReasons() {
      if (this.deliveryStatus.includes('smtp; 554 5.7.1')) {
        return [
          'The IP address has been included in a Real-Time Blacklist due to Spam coming from your domain.',
          'Your domain or IP address has been blacklisted by the recipient.',
        ];
      }

      if (this.deliveryStatus.includes('Status: 5.4.4')) {
        return [
          'The domain is not a valid domain and no MX and A records exist for the domain.',
          'If the domain is a valid domain, then the DNS server could not resolve the domain due to some network problem.',
        ];
      }

      return ['Unknown.'];
    },
    raw() {
      return this.bounceLog.message_raw || '';
    },
    boundary() {
      const regex = /(?<=boundary=)"(?<boundary>.*)"/;
      return this.raw.match(regex)?.[1] || null;
    },
    contents() {
      const lines = this.raw.split('\n');
      const startBoundary = `--${this.boundary}`;
      const endBoundary = `--${this.boundary}--`;

      const sections = [];
      let currentSection = -1;

      let reachedEndBoundary = false;
      while (lines.length && reachedEndBoundary === false) {
        const line = lines.shift();

        if (line.includes(endBoundary)) {
          reachedEndBoundary = true;
          continue;
        }

        if (line.includes(startBoundary)) {
          if (currentSection > -1) {
            sections[currentSection].content = sections[currentSection].content.trim();
          }
          currentSection += 1;
          sections[currentSection] = {
            description: '',
            type: '',
            content: '',
          };
          continue;
        }

        if (currentSection === -1) {
          continue;
        }

        if (line.includes('Content-Description: ')) {
          sections[currentSection].description = line.replace('Content-Description: ', '').trim();
          continue;
        }

        if (line.includes('Content-Type: ')) {
          sections[currentSection].type = line.replace('Content-Type: ', '').trim();
          continue;
        }

        sections[currentSection].content = [sections[currentSection].content, line].join('\n');
      }

      return sections;
    },
    notification() {
      const notification =
        this.contents.find((content) => content.description === 'Notification') || {};

      return notification?.content || '';
    },
    deliveryStatus() {
      const deliveryStatus =
        this.contents.find((content) => content.type === 'message/delivery-status') || {};

      return deliveryStatus?.content || '';
    },
  },
};
</script>
